/* eslint-disable import/prefer-default-export */

import {
  AsanaIcon,
  ClickupIcon,
  GongIcon,
  IntercomIcon,
  JiraIcon,
  LinearIcon,
  MondayIcon,
  ProductboardIcon,
  RoadmunkIcon,
  ShortcutIcon,
  SlackIcon,
  WrikeIcon,
  ZendeskIcon,
  ZohoSprintsIcon,
  ZoomIcon,
  ClariCopilotIcon,
} from '../icons'
import { IntegrationItem, IntegrationMethod, IntegrationCategoryParam, IntegrationSourceParam } from '../model'

import { CrmOptions, InsightsIntegrations, TasksIntegrationProductName } from '~generated/types'

export const integrations: IntegrationItem[] = [
  {
    Icon: SlackIcon,
    name: 'Slack',
    productName: 'SLACK',
    source: IntegrationSourceParam.SLACK,
    category: IntegrationCategoryParam.COMMUNICATION,
  },
  {
    name: 'Teams',
    productName: 'MS_TEAMS',
    source: IntegrationSourceParam.MS_TEAMS,
    category: IntegrationCategoryParam.COMMUNICATION,
  },
  {
    name: 'Salesforce',
    productName: CrmOptions.SALESFORCE,
    source: IntegrationSourceParam.SALESFORCE,
    category: IntegrationCategoryParam.CRM,
  },
  {
    name: 'Hubspot',
    productName: CrmOptions.HUBSPOT,
    source: IntegrationSourceParam.HUBSPOT,
    category: IntegrationCategoryParam.CRM,
  },
  {
    name: 'Microsoft Dynamics',
    productName: CrmOptions.MICROSOFT_DYNAMICS,
    source: IntegrationSourceParam.MICROSOFT_DYNAMICS,
    category: IntegrationCategoryParam.CRM,
  },
  {
    name: 'Pipedrive',
    productName: CrmOptions.PIPEDRIVE,
    source: IntegrationSourceParam.PIPEDRIVE,
    category: IntegrationCategoryParam.CRM,
  },
  {
    Icon: JiraIcon,
    name: 'Jira',
    productName: TasksIntegrationProductName.JIRA,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.JIRA,
    category: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    Icon: LinearIcon,
    name: 'Linear',
    productName: TasksIntegrationProductName.LINEAR,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.LINEAR,
    category: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    Icon: AsanaIcon,
    name: 'Asana',
    productName: TasksIntegrationProductName.ASANA,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.ASANA,
    category: IntegrationCategoryParam.PROJECT_MANAGEMENT,
  },
  {
    Icon: ProductboardIcon,
    name: 'Productboard',
    productName: TasksIntegrationProductName.PRODUCTBOARD,
    integrationMethod: IntegrationMethod.API_KEY,
    source: IntegrationSourceParam.PRODUCTBOARD,
    category: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    Icon: ClickupIcon,
    name: 'Click up',
    productName: TasksIntegrationProductName.CLICKUP,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.CLICKUP,
    category: IntegrationCategoryParam.PROJECT_MANAGEMENT,
  },
  {
    Icon: RoadmunkIcon,
    name: 'Roadmunk',
    productName: TasksIntegrationProductName.ROADMUNK,
    integrationMethod: IntegrationMethod.API_KEY,
    source: IntegrationSourceParam.ROADMUNK,
    category: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    Icon: ShortcutIcon,
    name: 'Shortcut',
    productName: TasksIntegrationProductName.SHORTCUT,
    integrationMethod: IntegrationMethod.API_KEY,
    source: IntegrationSourceParam.SHORTCUT,
    category: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    Icon: MondayIcon,
    name: 'Monday',
    productName: TasksIntegrationProductName.MONDAY,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.MONDAY,
    category: IntegrationCategoryParam.PROJECT_MANAGEMENT,
  },
  {
    Icon: WrikeIcon,
    name: 'Wrike',
    productName: TasksIntegrationProductName.WRIKE,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.WRIKE,
    category: IntegrationCategoryParam.PROJECT_MANAGEMENT,
  },
  {
    Icon: ZohoSprintsIcon,
    name: 'Zoho Sprints',
    productName: TasksIntegrationProductName.ZOHO_SPRINTS,
    integrationMethod: IntegrationMethod.OAUTH,
    source: IntegrationSourceParam.ZOHO_SPRINTS,
    category: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    Icon: IntercomIcon,
    name: 'Intercom',
    productName: InsightsIntegrations.INTERCOM,
    source: IntegrationSourceParam.INTERCOM,
    category: IntegrationCategoryParam.SUPPORT,
  },
  {
    Icon: ZendeskIcon,
    name: 'Zendesk',
    productName: InsightsIntegrations.ZENDESK,
    source: IntegrationSourceParam.ZENDESK,
    category: IntegrationCategoryParam.SUPPORT,
  },
  {
    Icon: GongIcon,
    name: 'Gong',
    productName: InsightsIntegrations.GONG,
    source: IntegrationSourceParam.GONG,
    category: IntegrationCategoryParam.CALL_TRANSCRIPTION,
  },
  {
    Icon: ZoomIcon,
    name: 'Zoom',
    productName: InsightsIntegrations.ZOOM,
    source: IntegrationSourceParam.ZENDESK,
    category: IntegrationCategoryParam.CALL_TRANSCRIPTION,
  },
  {
    Icon: ClariCopilotIcon,
    name: 'Clari Copilot',
    productName: InsightsIntegrations.CLARI_COPILOT,
    source: IntegrationSourceParam.CLARI_COPILOT,
    category: IntegrationCategoryParam.CALL_TRANSCRIPTION,
  },
]
